import React, { Component } from 'react';
import { BrowserRouter as Router,Link,Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import {Navbar, Nav} from 'react-bootstrap';
import 'font-awesome/css/font-awesome.min.css';
import res from './resume.pdf';
import './App.css';
import dp from './mine.jpg';

import Home from './writeups/home.js';
import WorkExp from './writeups/workexp.js';
import Projects from './writeups/projects.js';
import Publications from './writeups/publication.js';
import Articles from './writeups/articles.js';

class App extends Component {
  constructor(){
    super();
    this.state= {
      data : ""
    }
  }
  fromChild1(params) {
    this.setState();
  }

  render() {
    const name ="Aniruddh Khera";
  
    return (
     <div>
     <div className="App-header">

     </div>
     <div className="row">
     <Navbar fluid>
     <div className="col-xs-2"><img src={dp} className="Display-pic" alt="dp" /></div>
     <div className="col-xs-10">
        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>                        
      </button>
     <Nav pullRight> 
     <ul class="nav navbar-nav collapse navbar-collapse" id="myNavbar">
     <li> <a href="mailto:aniruddh.khera@nyu.edu"><div class="round-button mail big-icon">
              <i class="fa fa-envelope fa-lg" ></i>
          </div></a> </li>   
     <li><a href="https://www.linkedin.com/in/aniruddhkhera/"  target="_blank"> <div class="round-button linkedin big-icon">
          <i class="fa fa-linkedin-square fa-lg"></i>
          </div></a> </li>
     <li ><a href="https://github.com/kheraAniruddh"  target="_blank"> <div class="round-button github big-icon">
              <i class="fa fa-github-square fa-lg"></i>
          </div></a> </li>
     <li><a href="https://www.facebook.com/aniruddh.khera"  target="_blank"> <div class="round-button facebook big-icon">
              <i class="fa fa-facebook-square fa-lg"></i>
          </div> </a> </li>
  
      <li > <a  href="/profyl/resume.pdf" target="_blank"><div className="round-button linkedin big-icon"><i className="fa fa-paperclip"></i></div>Resume</a></li>    
     </ul>
     </Nav>
     </div>
     </Navbar>
     </div> 
     <Router>
     <div className="row">
        <div className="col-xs-2"> 
        <div className="Name">{name}</div>
        <ul className="nav nav-pills nav-stacked">
                  <li><Link to="/profyl/">Home</Link></li>
                  <li><Link to={"Workexp"}>Work Experience</Link></li>
                  <li><Link to={"Projects"}>Projects</Link></li>
                  <li><Link to={"Publications"}>Publications</Link></li>
                  <li><Link to={"Articles"}>Articles</Link></li>
        </ul>           
       </div>
        <div className="col-xs-9 App-content">
                   <Route exact path="/profyl/" component ={Home}/>
                   <Route path="/profyl/Workexp" component ={WorkExp}/>
                   <Route path="/profyl/Projects" component={Projects}/>
                    <Route path="/profyl/Publications" component={Publications}/>
                    <Route path="/profyl/Articles" component={Articles}/>

      </div>
      </div>
      </Router>  
     </div>
     );
   }
 }


 export default App;


// WEBPACK FOOTER //
// ./src/App.js